import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import HeroSection from './components/HeroSection';
import MethodologySection from './components/MethodologySection';
import ComplianceSection from './components/ComplianceSection';
import IndustrySection from './components/IndustrySection';
import DeliverablesSection from './components/DeliverablesSection';
import InteractiveToolsSection from './components/InteractiveToolsSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import EngagementSection from './components/EngagementSection';
import CTASection from './components/CTASection';

const BusinessValuation = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Business Valuation - Northbridge Valuation & Advisory</title>
        <meta
          name="description"
          content="Professional business valuation services for M&A, taxation, and strategic planning. CVA & CPA certified."
        />
        <meta name="keywords" content="business valuation, enterprise value, M&A valuation, tax valuation, CVA certified" />
        <link rel="canonical" href="/valuation" />
      </Helmet>
      <Header />

      <main>
        <HeroSection />
        <MethodologySection />
        <ComplianceSection />
        <IndustrySection />
        <DeliverablesSection />
        <InteractiveToolsSection />
        <CaseStudiesSection />
        <EngagementSection />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default BusinessValuation;